import { Product, useJurisdictionStore } from '@/hooks/use-jurisdiction';

export const useIsSweepsOrPredictionsProduct = () =>
    useJurisdictionStore(state => state.product === Product.Sweeps || state.product === Product.Prediction);
